import Events from '@utilities/events'
import toggleClass from '@utilities/toggle-class';

const JS_HOOK_CONTROL = '[js-hook-paged-navigation-control]';
const JS_HOOK_VIEW = '[js-hook-paged-navigation-view]';
const ANIMATION_ENTERING = 'paged-navigation--entering';
const ANIMATION_ENTERED = 'paged-navigation--entered';
const ANIMATION_EXITING = 'paged-navigation--exiting';
const ANIMATION_EXITED = 'paged-navigation--exited';
let ANIMATION_DURATION = '300'; // ms
const ANIMATION_STATES = [
  ANIMATION_ENTERING,
  ANIMATION_ENTERED,
  ANIMATION_EXITING,
  ANIMATION_EXITED
];

class PagedNavigation {
  constructor(element, args) {
    this.element = element;
    this.id = this.element.dataset.id || this.element.id;

    ANIMATION_DURATION = this.element.getAttribute('js-hook-paged-navigation-duration') || ANIMATION_DURATION;

    this.bindEvents();

    if (args && args.viewID) this.showView(args.viewID, args.scrollTop, args.scrollList, false);
  }

  bindEvents() {
    Events.$on(`pagedNavigation[${this.id}]::changeView`, (e, data) => {
      this.showView(data.viewID, null, null, data.animate);
    });

    this.element.addEventListener(
      'click',
      event => {
        const target = event.target.closest(JS_HOOK_CONTROL);
        if (!target) return;

        const viewID = target.getAttribute('aria-controls');
        this.showView(viewID);
      },
      false
    );
  }

  /**
   * Show view based on control
   */
  showView(viewID, scrollTop = null, scrollList = null, animate = true) {
    // reset: Hide views
    const hideThese = [
      ...this.element.querySelectorAll(`${JS_HOOK_VIEW}:not(.${ANIMATION_EXITED})`)
    ].filter(visibleView => visibleView.getAttribute('id') !== viewID);
    const showThese = [...this.element.querySelectorAll(`#${viewID}:not(.${ANIMATION_ENTERED})`)];

    if (showThese.length < 1) return;

    if (this.animationTimer) clearTimeout(this.animationTimer);

    if (animate) {
      hideThese.forEach(view => {
        toggleClass(view, ANIMATION_STATES, false);
        toggleClass(view, ANIMATION_EXITING, true);
      });
      showThese.forEach(view => {
        toggleClass(view, ANIMATION_STATES, false);
        toggleClass(view, ANIMATION_ENTERING, true);
      });
      this.animationTimer = setTimeout(() => {
        hideThese.forEach(view => {
          toggleClass(view, ANIMATION_STATES, false);
          toggleClass(view, ANIMATION_EXITED, true);
        });
        showThese.forEach(view => {
          toggleClass(view, ANIMATION_STATES, false);
          toggleClass(view, ANIMATION_ENTERED, true);
        });
      }, ANIMATION_DURATION);
    } else {
      hideThese.forEach(view => {
        toggleClass(view, ANIMATION_STATES, false);
        toggleClass(view, ANIMATION_EXITED, true);
      });
      showThese.forEach(view => {
        toggleClass(view, ANIMATION_STATES, false);
        toggleClass(view, ANIMATION_ENTERED, true);
      });
    }

    if (scrollTop && scrollList) scrollList.scrollTop = scrollTop;

    Events.$trigger(`pagedNavigation[${this.id}]::changedView`, {
      data: {
        viewID
      }
    });

    Events.$trigger(`pagedNavigation::changedView`);
  }
}

export default PagedNavigation;
